<ef-process-detail [process]="process$ | async"></ef-process-detail>
<ef-oversign-time-presenter [oversignData]="oversign$ | async">
</ef-oversign-time-presenter>
